export enum ScrollMode {
    Carousel = 'carousel',
    Default = 'default',
    Horizontal = 'horizontal',
    Responsive = 'responsive',
}
